module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_11.81998dad.jpeg";